import { useLocation, useHistory } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

// Import helpers
import { CONFIGURATOR_STEPS } from 'components/views/offer_configurator/helpers/steps';
import { sendBeginCheckoutEvent } from 'helpers/tracking';

// Import hooks
import { usePrePaymentMail, useSummaryStore } from 'components/views/offer_configurator/hooks';

export const useNavigationButtons = () => {
	const history = useHistory();
	const location = useLocation();
	const mail = usePrePaymentMail();
	const [main, premium, summary] = useSummaryStore(useShallow((state) => [state.main, state.premium, state.summary]));

	const activeStep = CONFIGURATOR_STEPS.findIndex(({ path }) => path === location.pathname);

	const isLastStep = activeStep === CONFIGURATOR_STEPS.length - 1;

	const handleNavigate = (i: number) => (event: React.MouseEvent<HTMLButtonElement>) => {
		if (event.currentTarget.type !== 'button') return;

		if (activeStep === 0) {
			sendBeginCheckoutEvent(summary?.products);
			mail.mutate({ main, premium });
		}

		const step = CONFIGURATOR_STEPS[activeStep + i];
		step && history.push(step.path);
	};

	return { activeStep, isLastStep, handleNavigate };
};
